import Component from "~/route-containers/about-us/about-us.container";
import { json, LoaderFunction } from "@remix-run/node";
import { i18n } from "~/config/i18n/i18n.server";

export { AboutUsMetaData as meta } from "~/route-containers/about-us/about-us.container";

export const loader: LoaderFunction = async ({ request }) => {
  let t = await i18n.getFixedT(request);
  const descriptionAboutUs = `${t(
    "about_meta_data.title",
  )} {{enterpriseName}} ${t("about_meta_data.connector")}`;

  return json({
    descriptionAboutUs,
  });
};
export default Component;
